/*
 * サブシステム名：請求消込
 * 機能名：請求消込一覧
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')

export default {
  name: 'SeikyuKeshikomiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdDateRangeBox
  },
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      seikyusakiCd: '',
      seikyuKeshikomiYmdFromString: '',
      seikyuKeshikomiYmdToString: ''
    },
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      seikyusakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki'
    }),
    filteredSeikyusaiList () {
      const target = filter.dateFormatter(new Date())
      return this.seikyusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        if (elem.seikyuKeshikomiYmd !== null) {
          elem.seikyuKeshikomiYmdDisp = filter.dateFormatter(elem.seikyuKeshikomiYmd)
        }
        if (elem.seikyuKeshikomiKingaku === null || elem.seikyuKeshikomiKingaku === undefined) {
          elem.seikyuKeshikomiKingakuDisp = ''
        } else {
          elem.seikyuKeshikomiKingakuDisp = filter.numericFormatter(elem.seikyuKeshikomiKingaku)
        }
        if (elem.nyukinKeshikomiKingaku === null || elem.nyukinKeshikomiKingaku === undefined) {
          elem.nyukinKeshikomiKingakuDisp = ''
        } else {
          elem.nyukinKeshikomiKingakuDisp = filter.numericFormatter(elem.nyukinKeshikomiKingaku)
        }
        if (elem.shiwakeKeshikomiKingaku === null || elem.shiwakeKeshikomiKingaku === undefined) {
          elem.shiwakeKeshikomiKingakuDisp = ''
        } else {
          elem.shiwakeKeshikomiKingakuDisp = filter.numericFormatter(elem.shiwakeKeshikomiKingaku)
        }
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['vwcmsttorihikisakigetseikyusaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: '詳細', value: 'detailref' },
              { text: '消込No', value: 'seikyuKeshikomiNo' },
              { text: '消込年月日', value: 'seikyuKeshikomiYmdDisp', align: 'center' },
              { text: '担当者', value: 'tantoNm' },
              { text: '請求先', value: 'seikyusakiNm' },
              { text: '請求消込額', value: 'seikyuKeshikomiKingakuDisp', align: 'end' },
              { text: '入金消込額', value: 'nyukinKeshikomiKingakuDisp', align: 'end' },
              { text: '手数料・調整・相殺等', value: 'shiwakeKeshikomiKingakuDisp', align: 'end' },
              { text: '備考', value: 'seikyuKeshikomiBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              seikyusakiCd: '',
              seikyuKeshikomiYmdFromString: filter.dateFormatter(new Date()),
              seikyuKeshikomiYmdToString: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2bcld0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            // ﾕｰｻﾞｰ保存項目なし
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              seikyusakiCd: '',
              seikyuKeshikomiYmdFromString: filter.dateFormatter(new Date()),
              seikyuKeshikomiYmdToString: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      if (f.item.shubetsu !== '入金予定表') {
        this.Effects.loadStart()
        this.transition(0, { id: f.item.id })
      }
    },
    onRowDetailButtonClick: function (item) {
      // 画面遷移
      if (item.shubetsu !== '入金予定表') {
        this.Effects.loadStart()
        this.transition(0, { id: item.id })
      }
    },
    onCsvButtonClick: function (e) {
      this.Effects.loadStart()
      this.HttpClient
        .post('/api/v1/vwCD2bcld0010/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.Effects.loadComplete()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      // 消込日の大小チェック
      if (this.conditions.seikyuKeshikomiYmdFromString && this.conditions.seikyuKeshikomiYmdToString) {
        var msg = validators.compareDate(this.conditions.seikyuKeshikomiYmdFromString, this.conditions.seikyuKeshikomiYmdToString)
        if (msg !== undefined) {
          this.$refs.seikyuKeshikomiYmdFromString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.seikyuKeshikomiYmdToString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    }
  }
}
